export enum WhatsAppTemplateType {
  AfterGivingAQuote = 1,
  AfterAppointmentNoShow,
  AfterNotAnsweringCustomerQuestion,
  OnPendingPaymentWithMercadoPagoLink,
  SiteForAppointmentsLink
}